export const citiesData = [
  { id: 'buckeye', name: 'Buckeye', color: 'bg-retro-teal' },
  { id: 'goodyear', name: 'Goodyear', color: 'bg-retro-yellow' },
  { id: 'surprise', name: 'Surprise', color: 'bg-retro-blue', textColor: 'text-white' },
  { id: 'avondale', name: 'Avondale', color: 'bg-retro-green', textColor: 'text-white' },
  { id: 'glendale', name: 'Glendale', color: 'bg-retro-yellow' },
  { id: 'peoria', name: 'Peoria', color: 'bg-retro-teal' },
  { id: 'litchfield', name: 'Litchfield Park', color: 'bg-retro-blue', textColor: 'text-white' }
];

export const layoutConfig = {
  front: [
    // Top Section (4 slots)
    { id: 't-large', type: 'Large Ad', size: '4" x 6"' },
    { id: 't-med', type: 'Medium Ad', size: '4" x 3"' },
    { id: 't-s1', type: 'Half-Size Ad', size: '2" x 3"' },
    { id: 't-s2', type: 'Half-Size Ad', size: '2" x 3"' },
    // Bottom Section (6 slots across 4 columns)
    { id: 'b-s1', type: 'Small Ad', size: 'Quarter Size' },
    { id: 'b-s2', type: 'Small Ad', size: 'Quarter Size' },
    { id: 'b-t1', type: 'Vertical Ad', size: 'Half Size' },
    { id: 'b-t2', type: 'Vertical Ad', size: 'Half Size' },
    { id: 'b-s3', type: 'Small Ad', size: 'Quarter Size' },
    { id: 'b-s4', type: 'Small Ad', size: 'Quarter Size' },
  ],
  back: [
    // Top Section (4 slots)
    { id: 't-large', type: 'Large Ad', size: '4" x 6"' },
    { id: 't-med', type: 'Medium Ad', size: '4" x 3"' },
    { id: 't-s1', type: 'Half-Size Ad', size: '2" x 3"' },
    { id: 't-s2', type: 'Half-Size Ad', size: '2" x 3"' },
    // Bottom Section (6 slots across 4 columns)
    { id: 'b-s1', type: 'Small Ad', size: 'Quarter Size' },
    { id: 'b-s2', type: 'Small Ad', size: 'Quarter Size' },
    { id: 'b-t1', type: 'Vertical Ad', size: 'Half Size' },
    { id: 'b-t2', type: 'Vertical Ad', size: 'Half Size' },
    { id: 'b-s3', type: 'Small Ad', size: 'Quarter Size' },
    { id: 'b-s4', type: 'Small Ad', size: 'Quarter Size' },
  ]
};